import BaseApi from "./_base-api";

/**
 * Content API
 *
 * @class Api
 * @extends {BaseApi}
 */
class Api extends BaseApi {
	getOne(params) {
		const id = params instanceof Object ? params.id : params;
		if(params instanceof Object && params.id) {
			delete params.id;
		}
		return this.api()
			.get(this.getUrl("content") + '/' + id, { params })
			.catch(error => {
				this.log().error("[Services Error: Content: Getting content]:", error);
				throw this.utils.resolveError(error);
			});
	}
}

const api = new Api({
	type: "Content",
	path: "primary_contents"
});

export default api;
